module.exports = __webpack_public_path__ + "static/media/boy-8.d8dcf0ef.svg";